export default {
    methods: {
        setDataByParam(data, param, dataKey, label) {
            
            this[dataKey] = data[dataKey]
                ? [{ id: -1, name: label }, ...data[dataKey]]
                : [{ id: -1, name: label }];

            if (this[param] != -1 && ! this[dataKey].find(item => item.id == this[param])) {
                this[param] = -1;
            }
            
        }
    }
}